import { FormEvent, useState } from "react";
import { apiPost, type SessionPayload } from "../api";

export function ChangePasswordDialog({
  session,
  onDone,
  onCancel,
}: {
  session: SessionPayload;
  onDone: (next: SessionPayload) => void;
  onCancel: () => void;
}) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      const res = await apiPost<SessionPayload & { ok?: boolean; error?: string }>(
        "/api/account/change-password",
        { current_password: currentPassword, password, password2 },
        session.csrfToken
      );
      if (res.error) {
        setError(res.error);
        return;
      }
      onDone(res);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not change password.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="cr-modal-backdrop" role="dialog" aria-labelledby="change-password-title">
      <div className="mapping-card cr-modal">
        <div className="cr-modal-head">
          <h3 id="change-password-title">Change Password</h3>
          <button type="button" className="cr-modal-close" aria-label="Close" onClick={onCancel}>
            ×
          </button>
        </div>
        <form className="users-admin-form" onSubmit={onSubmit}>
          {error ? <p className="users-admin-banner users-admin-banner-warn">{error}</p> : null}
          <label className="users-admin-label">
            <span>Current password</span>
            <input
              className="users-admin-input"
              type="password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              required
            />
          </label>
          <label className="users-admin-label">
            <span>New password</span>
            <input
              className="users-admin-input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              minLength={8}
              required
            />
          </label>
          <label className="users-admin-label">
            <span>Confirm password</span>
            <input
              className="users-admin-input"
              type="password"
              value={password2}
              onChange={(event) => setPassword2(event.target.value)}
              minLength={8}
              required
            />
          </label>
          <div className="users-admin-actions">
            <button type="submit" className="users-admin-btn-primary" disabled={saving}>
              {saving ? "Saving…" : "Save password"}
            </button>
            <button type="button" className="users-admin-btn-ghost" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
